import { DatePicker, Form, Input, Modal, Row, Select, Space, notification } from 'antd';
import axios from 'axios';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { DATE_FORMAT } from '../false-deals-admin.constants';
import { FileTypes } from '../false-deals-admin.types';
import { getTaxpayerOptions } from '../false-deals-admin.utils';
import FileUploadItem from './file-upload-item';
import { filterDigits } from '/react4xp/mixins/helpers';
import Button from '/react4xp/mixins/ui/button/button';

export const FalseDealModal = ({
    isModalOpen,
    handleCancel,
    handleOk,
    modalForm,
    taxpayers,
    activeId,
    isEdit,
    setTaxpayers,
    isSaving,
}) => {
    const handleCheckTaxpayercode = ({ target: { value } }) => {
        modalForm.validateFields(['taxpayerCode']).then(() => {
            if (!value || value.trim().length !== 12) return;
            modalForm.resetFields(['fullName']);

            axios
                .get('/services/isnaportal/open-api/knp-taxpayer', {
                    params: {
                        taxpayerCode: value,
                    },
                })
                .then((res) => res.data)
                .then((taxpayerData) => {
                    if (!Array.isArray(taxpayerData) || taxpayerData.length === 0) {
                        notification.error({
                            message: 'Ошибка',
                            description:
                                'Извините, ИИН/БИН Налогоплательщика не найден в системе, проверьте корректность вводимых данных',
                        });
                    }
                    setTaxpayers(taxpayerData);
                });
        });
    };

    return (
        <Modal
            title={isEdit ? 'Редактировать сделку' : 'Добавить лжесделку'}
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
        >
            <Form
                name="basic"
                layout="vertical"
                form={modalForm}
                onFinish={handleOk}
            >
                <Form.Item
                    label="ИИН/БИН"
                    name="iinBin"
                    rules={[
                        {
                            required: true,
                            message: 'Поле обязательно для заполнения',
                        },
                        {
                            min: 12,
                            message: 'Поле ИИН должно состоять из 12 цифр',
                        },
                    ]}
                >
                    <Input
                        onChange={filterDigits(modalForm, 'iinBin')}
                        onBlur={handleCheckTaxpayercode}
                        maxLength={12}
                        size="large"
                        placeholder="Введите значение"
                        className="input"
                    />
                </Form.Item>
                <Form.Item
                    label="ФИО/Наименование организации"
                    name="fullName"
                    rules={[
                        {
                            required: true,
                            message: 'Поле обязательно для заполнения',
                        },
                    ]}
                >
                    <Select
                        size="large"
                        placeholder="Введите значение"
                        options={getTaxpayerOptions(taxpayers)}
                    />
                </Form.Item>
                <Form.Item
                    name="preparationDate"
                    label="Дата составления акта"
                    rules={[
                        {
                            required: true,
                            message: 'Поле обязательно для заполнения',
                        },
                    ]}
                >
                    <DatePicker
                        format={DATE_FORMAT}
                        disabledDate={(current: Dayjs) => current && current > dayjs().endOf('day')}
                    />
                </Form.Item>
                <Form.Item
                    name="actNumber"
                    label="Номер акта"
                    rules={[
                        {
                            required: true,
                            message: 'Поле обязательно для заполнения',
                        },
                        {
                            max: 30,
                            message: 'Максимум 30 символов',
                        },
                        {
                            pattern: new RegExp(
                                /^[\p{L}\p{N}#№\(]+[\p{L}\p{N}\-\\/.|,_\s:;#№\(\)*]*$/u
                            ),
                            message: 'Неверный формат номера акта',
                        },
                    ]}
                >
                    <Input
                        type="text"
                        size="large"
                        placeholder="Введите значение"
                        className="input"
                    />
                </Form.Item>
                {activeId ? (
                    <FileUploadItem
                        form={modalForm}
                        name={FileTypes.CONFIRMATION}
                    />
                ) : (
                    <>
                        <FileUploadItem
                            form={modalForm}
                            name={FileTypes.ACT}
                        />
                        <FileUploadItem
                            form={modalForm}
                            name={FileTypes.COUNTERPARTY}
                        />
                    </>
                )}
                <Row justify="end">
                    <Space>
                        <Form.Item>
                            <Button onClick={handleCancel}>Отменить</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                color="gold"
                                loading={isSaving}
                            >
                                {isEdit ? 'Сохранить' : 'Создать'}
                            </Button>
                        </Form.Item>
                    </Space>
                </Row>
            </Form>
        </Modal>
    );
};
